import { ProductTypes } from '../enums/ProductEnums';
import { AppliedVoucherTypes } from '../enums/VoucherEnums';
import { ProductColorVariationSize } from '../product-detail/ProductTypes';
import { PickupPoint } from './PickupPoint';
import { ProductPrices } from '../product-detail/ProductPriceTypes';
import { DeliveryOptionsEnum } from '../DeliveryPromise';

export type ConfirmationDeliveryInfo = {
  clickAndCollectDeliveryInfo: string;
  emailDispatchText?: string;
  emailPickupTextPickupPoint?: string;
  emailPickupTextShop?: string;
  homeDeliveryInfo: string;
  pickupPointDeliveryInfo: string;
  deliveryPromise?: string; // shoplanding delivery promise
};

export type ConfirmationNewsletter = {
  checkboxText: string;
  subscribedMessage?: string;
  unsubscribedMessage?: string;
};

export type ConfirmationOrderInfo = {
  emailNotificationText: string;
  orderNumberText: string;
};

export type ConfirmationSupport = {
  href: string;
  info: string;
  linkLabel: string;
};

export type ConfirmationUSP = {
  fourLabel: string;
  oneLabel: string;
  sendMessage: string;
  successMessage: string;
  threeLabel: string;
  twoLabel: string;
};

export type ConfirmationVoucher = {
  digitalDeliveryInfo: string;
};

export type ConfirmationAppliedVoucher = {
  amountOriginal: number;
  amountUnused: number;
  amountUsedForThisBasket: number;
  barcode: string;
  description?: string;
  displayCode: string;
  message: string;
  minAmount?: number;
  printable?: boolean;
  showAmount: boolean;
  showValidate?: boolean;
  singleUse: boolean;
  type: AppliedVoucherTypes;
  valid: boolean;
  validFrom: Date | string;
  validTo: Date | string;
};

export type ConfirmationDeliveryAddressResource = {
  country: string;
  idCountry: number;
  postCode: string;
  city: string;
  houseNumber: string;
  address: string;
  companyName?: string;
  addToProfile: boolean;
  organisationName?: string;
  locationName?: string;
  pickupPointNumber?: string;
  storeId?: number;
  storeNumber?: number;
  addtoProfile?: boolean;
  firstName?: string;
  lastName?: string;
};

export type ConfirmationMappedProduct = {
  productCode: string;
  description: string;
  image: string;
  quantity: number;
  productId?: string;
  additionalImage?: string;
  brand?: string;
  color?: string;
  colorId?: number;
  eVoucherId?: string;
  price?: number;
  priceManual?: number;
  previousPrice?: number;
  totalPrice?: number;
  totalPreviousPrice?: number;
  productType?: ProductTypes;
  seoUrl?: string;
  sizeDescription?: string;
  originalSize?: string;
  colorDescription?: string;
  swatch?: string;
  sku?: number;
  productHasDiscount?: boolean;
  size: ProductColorVariationSize;
  sizes?: Array<ProductColorVariationSize>;
  prices: ProductPrices;
};

export type ConfirmationOrder = {
  contactPerson: string;
  customerUUID: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  deliveryOption: DeliveryOptionsEnum;
  contactAddress?: {
    idCountry: number;
  };
  deliveryAddressResource: ConfirmationDeliveryAddressResource | null;
  orderNumber: string;
  requiresDelivery: boolean;
  hasEvoucher: boolean;
  currency: string;
  deliveryTime: string;
  deliveryUnit: string;
  hasDeliveryMessage: boolean;
  deliveryMessage: string;
  vouchers?: Array<ConfirmationAppliedVoucher>;
  products: Array<ConfirmationOrderProduct>;
  mappedProducts: Array<ConfirmationMappedProduct>;
  paymentMethod: string;
  deliveryDate: number;
  deliveryDateFrom: number;
  deliveryDateTo: number;
  priceDelivery: number;
  priceTotalBasket: number;
  totalBasketDiscountAmount: number;
  totalPriceSell: number;
  totalPriceSellBeforeDiscount: number;
  locationDTO?: PickupPoint;
};

export type ConfirmationOrderProduct = {
  productCode: string;
  productId: number;
  sku: number;
  colorId: number;
  quantity: number;
  productPriceStandard: number;
  productPriceSell: number;
  totalProductPriceSell: number;
  productType: ProductTypes;
  pdpPrices: ProductPrices;
};

export type ConfirmationContainerProps = {
  deliveryInfo: ConfirmationDeliveryInfo;
  newsletter: ConfirmationNewsletter;
  orderInfo: ConfirmationOrderInfo;
  support?: Partial<ConfirmationSupport>;
  usp?: Partial<ConfirmationUSP>;
  voucher: ConfirmationVoucher;
};

export type PaymentRequestConfirmationContainerProps = {
  link: string;
};
